import React, {useState, useEffect, useContext} from "react";
import AdminListPage from '../administration/components/AdminListPage';
import Header from "../../components/Header";
import LeftMenu from "../../components/LeftMenu";


export default function AdministrationGeographies(){
	
	const thisContainer = {
		display:"flex",
		width:"calc(100% - 60px)",
		minHeight:"100vh",
		backgroundColor:"white",
		flexDirection:"column",
		//overflow:"auto",
		paddingBottom:"100px",
		marginLeft:"60px",
		marginTop:"60px"
	};
	
	return (
		<div style={thisContainer}>
				<Header/>
				<LeftMenu/>
			<AdminListPage
					title="Geographies (Regions, Countries, Cities)"
					headerTitle="Name"
					headerDescription="Description"
					restUrl="adminlistgeographies"
					adminPage="administrationgeographiesedit"
					downloadUrl="spreadsheetexportgeography"
					uploadUrl="spreadsheetimportgeography"
				/>
		</div>
	);
}